<template lang="html">
	<div>
		<div v-show="realLaunch" class="modal-container row" :class="{activated: launch}" @mousedown="close">
			<div class="modal-content" :class="modalContentClass" @mousedown.stop>

				<div class="inner-modal">
					<div class="head-modal">
						<slot name="header"></slot>
						<button type="button"
										class="close"
										@click="close"
										data-dismiss="modal"
										aria-hidden="true"
						>×</button>
					</div>

					<div class="body-modal">
						<slot></slot>
					</div>

					<div class="footer-modal">
						<slot name="footer"></slot>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Modal',
	props: ['show', 'modalContentClass'],
	data () {
		return {
			launch: false,
			realLaunch: false
		}
	},
	mounted () {
		if (this.show) {
			this.launch = true
			this.realLaunch = true
		}
	},
	methods: {
		close () {
			this.$emit('close')
		}
	},
	watch: {
		show (value) {
			if (value) {
				this.realLaunch = true
				window.setTimeout(() => { this.launch = true }, 10)
			} else {
				window.setTimeout(() => { this.launch = false }, 10)
				window.setTimeout(() => { this.realLaunch = false }, 510)
			}
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/common/components/Modal.vue